import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy, OnInit,
  Output,
} from "@angular/core";

import { PageService } from "../services/page.service";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/guards/auth.service";
import {InfoSistema} from './info-sistema';
import {SystemService} from './system.service';

@Component({
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements AfterViewChecked, OnDestroy, OnInit {

  infoSistema: InfoSistema;
  private subscriptions = new Subscription();

  @Output() openMenu = new EventEmitter();
  globalTitle: string;
  openSideMenu: boolean;
  showMenu: boolean;
  username = localStorage.getItem("username");
  password = localStorage.getItem("password");
  theme = localStorage.getItem("colorSelected");
  globalSubTitle: string;
  menuOpen: any;

  constructor(
    private router: Router,
    private cd: ChangeDetectorRef,
    private PageService: PageService,
    private authService: AuthService,
    private systemService: SystemService
  ) {}

  clickOpenMenu(event) {
    this.openSideMenu = !this.openSideMenu;
    this.openMenu.emit(this.openSideMenu);
  }

  ngAfterViewChecked() {
    this.subscriptions.add(
      this.PageService.title.subscribe((newTitle) => {
        this.globalTitle = newTitle;
        this.cd.detectChanges();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  outSystem() {
    this.authService.logout();
  }

  selectTheme($event: any) {}

  infoSistemaDisponivel() {
    return this.infoSistema != null;
  }

  ngOnInit(): void {
    this.systemService.getSystemInfo().subscribe(value => this.infoSistema = value);
  }
}
